export default `
... on entryBlocks_checkList_BlockType {
  baseCheckList {
    ... on baseCheckList_checkListItem_BlockType {
        copy
    }
  }
}
`;
